import QuoteSignCard from './QuoteSignCard'

export * from './QuoteSignCard'
export default QuoteSignCard
